import React from 'react';
import { FileIcon } from 'elements/Icon';

const MOV = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="12.448" y="102.874" width="74" height="24"/>
    <path d="M29.995,36v52.006l40.862-26.003L29.995,36z"/>
    <g>
      <path fill="#FFFFFF" className="text" d="M27.464,120.632V118.3h2.333v2.332H27.464z"/>
      <path fill="#FFFFFF" className="text" d="M32.171,120.632v-12.169h3.677l2.208,8.301l2.183-8.301h3.686v12.169h-2.283v-9.579l-2.416,9.579H36.86
        l-2.407-9.579v9.579H32.171z"/>
      <path fill="#FFFFFF" className="text" d="M45.867,114.623c0-1.239,0.186-2.28,0.557-3.121c0.276-0.62,0.654-1.176,1.133-1.668
        c0.479-0.493,1.003-0.858,1.573-1.096c0.758-0.321,1.633-0.482,2.623-0.482c1.793,0,3.228,0.557,4.304,1.669
        s1.615,2.659,1.615,4.64c0,1.965-0.534,3.502-1.603,4.611s-2.496,1.664-4.283,1.664c-1.81,0-3.248-0.552-4.316-1.655
        C46.401,118.08,45.867,116.559,45.867,114.623z M48.399,114.54c0,1.378,0.318,2.423,0.954,3.134
        c0.637,0.711,1.445,1.066,2.424,1.066c0.98,0,1.784-0.353,2.412-1.059c0.628-0.705,0.941-1.764,0.941-3.175
        c0-1.395-0.306-2.435-0.917-3.121s-1.423-1.029-2.437-1.029c-1.012,0-1.828,0.348-2.448,1.042S48.399,113.139,48.399,114.54z"/>
      <path fill="#FFFFFF" className="text" d="M62.694,120.632l-4.35-12.169h2.664l3.08,9.007l2.979-9.007h2.606l-4.357,12.169
        C65.316,120.632,62.694,120.632,62.694,120.632z"/>
    </g>
  </FileIcon>
);

export default MOV;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/MOV.jsx